// @owner ClientPlatform
/* eslint-disable jsx-a11y/label-has-associated-control */

import type {FC, MouseEventHandler, PropsWithChildren} from 'react';
import React from 'react';
import type {SwitchToSigninPage} from '../../helpers/pageHelpers';
import {SigninPage} from '../../helpers/pageHelpers';
import {StyledThirdPartySigninRow, StyledButtonIcon, StyledFieldsGroup} from '../../commonSigninStyles';
import {Text} from '../../../common/components/text';
import {AuthCard} from '../../components/authCard/authCard';
import {FullWidthButton} from '../../../common/components/button';
import googleIconSrc from '../../../assets/google.svg';
import officeIconSrc from '../../../assets/office.svg';

interface OauthOnlyProps {
  switchToSigninPage: SwitchToSigninPage;
  googleSignin: MouseEventHandler<HTMLElement>;
  officeSignin: MouseEventHandler<HTMLElement>;
}

export const OauthOnly: FC<PropsWithChildren<OauthOnlyProps>> = ({switchToSigninPage, googleSignin, officeSignin}) => {
  return (
    <AuthCard name="oauthOnlySignInForm">
      <StyledFieldsGroup>
        <Text as="h1" variant="title-small-semibold">
          Sign in to {location.host}
        </Text>
        <p>Your company requires you to login with Google or Office 365.</p>
      </StyledFieldsGroup>

      <StyledThirdPartySigninRow>
        <FullWidthButton
          type="button"
          variant="secondary"
          onClick={googleSignin}
          leadingAccessory={<StyledButtonIcon src={googleIconSrc} alt="" />}
        >
          Google
        </FullWidthButton>
        <FullWidthButton
          type="button"
          variant="secondary"
          onClick={officeSignin}
          leadingAccessory={<StyledButtonIcon src={officeIconSrc} alt="" />}
        >
          Office 365
        </FullWidthButton>
      </StyledThirdPartySigninRow>

      <FullWidthButton variant="secondary" type="button" onClick={() => switchToSigninPage(SigninPage.LOGIN)}>
        Back to login
      </FullWidthButton>
    </AuthCard>
  );
};
